module.exports = __webpack_public_path__ + "assets/img/18_1776_big.b286c0d0.jpg";